//
// Copyright (c) 2011-2024 by Bazaarvoice, Inc.
//
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { StreamSourceTypes } from '@streams/constants/streamCreationConstants';

export const getMultiHandleAccountsUserId = createSelector(
  (state: ICuralateStore) => state.streams.streamCreation.sourcesAdded,
  (state: ICuralateStore) =>
    state.facebookInstagramSettings.connectedInstagramAccounts,
  (sourcesAdded, connectedInstagramAccounts) => {
    const multiHandleUser = sourcesAdded
      .filter((src) => src.sourceType === StreamSourceTypes.MENTIONS_AND_TAGS)
      .map((src) => src.sourceValue);

    if (multiHandleUser.length === 0) {
      return null;
    }
    const multiHandleUserId = connectedInstagramAccounts?.find(
      (account) => account.username === multiHandleUser[0],
    );

    return multiHandleUserId?.userId || null;
  },
);
